import axios from 'axios'
import config from './config'
import { getToken } from '@/utils/auth';
import { Message, MessageBox } from 'element-ui'

// 使用vuex做全局loading时使用
import store from '@/store'


const header = {
	formData:{
		'Content-Type': 'application/x-www-form-urlencoded'
	},
	payload:{
		'Content-Type': 'application/json;charset=UTF-8'
	},
};

export default function $axios(options) {
	return new Promise((resolve, reject) => {
		// from axios
		// console.log(options)
		const instance = axios.create({
			baseURL: options.url.indexOf('/static/') > -1 ? '' : process.env.BASE_API,
			headers:options.payload?header.payload:header.formData,
			// useRequestBody:options.payload,
			timeout: process.env.BASE_API == 'development' ? 60*1000 :  60*60*1000, // 请求超时时间
			withCredentials: true,//false会导致sessions会变
		});

		// request 拦截器
		instance.interceptors.request.use(
			config => {
				// 这里可以自定义一些config 配置
				// loading + 1
				store.dispatch('SetLoading', true);
				return config;
			},

			error => {
				// 请求错误时
				console.log('request:', error)
				//判断请求超时
				if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
					console.log('timeout请求超时')
					// return service.request(originalRequest);// 再重复请求一次
				}
				// loading 清 0
				setTimeout(function() {
					store.dispatch('SetLoading', 0);
				}, 300);

				Promise.reject(error);
			}
		)

		// response 拦截器
		instance.interceptors.response.use(
			response => {
				const res = response.data;
				store.dispatch('SetLoading', false);

				if(res.msgType != 'nomsg') {
					Message({
						message: res.msg,
						center: true,
						type: res.msgType,
					})
				}
				if(res.msgType != "success" && res.msgType != 'info' && res.msgType != 'nomsg') {
					return Promise.reject('error')
				}else {
					return res
				}
			},
			error => {
				// 这里处理一些response 出错时的逻辑

				// loading - 1
				store.dispatch('SetLoading', false);

				return Promise.reject(error);
			}
		);

		// 请求处理
		instance(options).then(res => {
			resolve(res)
			return false
		}).catch(error => {
			reject(error)
		})
	})
}


// WEBPACK FOOTER //
// ./src/http/axios.js